/** Moving to a new city for work: the journey, its checklist, and the city guide (a draft from public sources). */
export const landing = {
    "landing.title": "Moving to a new city",
    "landing.draft": "Draft from public sources. Not yet checked by a union.",
    "landing.loading": "Getting the guide…",
    "landing.no_guide": "The guide could not be downloaded. Connect to the internet once and it stays on this phone.",
    "landing.offline": "No internet: showing the guide saved on this phone on {date}.",
    "landing.start_title": "Where are you moving?",
    "landing.city": "City",
    "landing.city_only": "Only cities with a guide are here for now.",
    "landing.city.bengaluru": "Bengaluru",
    "landing.arrival": "When do you arrive?",
    "landing.trade": "Your work",
    "landing.start": "Start the guide",
    "landing.problem_city": "Pick a city.",
    "landing.problem_arrival": "Pick the day you arrive.",
    "landing.problem_trade": "Pick your work.",
    "landing.arriving": "{city} · arriving {date} · {trade}",
    "landing.step.planning": "Planning",
    "landing.step.travelling": "Travelling",
    "landing.step.arrived": "Arrived",
    "landing.step.housed": "A place to stay",
    "landing.step.documented": "Documents",
    "landing.step.registered": "Registration",
    "landing.step.working": "Working",
    "landing.step.settled": "Settled",
    "landing.steps": "Steps of the move",
    "landing.step_of": "Step {n} of {total}",
    "landing.done_count": "{done} of {total} done",
    "landing.next": "Next step: {step}",
    "landing.back_step": "Back to {step}",
    "landing.ticked_app": "Ticked by the app: a job both of you signed in the city.",
    "landing.fixed_money": "Keep money aside for the first month (see the cash plan)",
    "landing.fixed_documents": "Pack your Aadhaar card, two photos of yourself and copies of any other ID",
    "landing.fixed_tell_home": "Tell someone at home where you will stay and when you arrive",
    "landing.fixed_share_trip": "Send your train or bus details to someone at home",
    "landing.fixed_save_address": "Write down the address where you are staying",
    "landing.fixed_rent_receipt": "Ask for a written rent agreement or a receipt for rent",
    "landing.fixed_no_deposit_unseen": "Never pay a deposit for a room you have not seen",
    "landing.fixed_copies": "Keep photos of your documents on your phone",
    "landing.fixed_card_area": "Update your card with your new area",
    "landing.fixed_first_job": "Get your first job in the new city",
    "landing.fixed_help_next": "Help someone else who is new to the city",
    "landing.read": "Read what the guide says",
    "landing.sources": "Where this comes from",
    "landing.source_read": "{title} (read {date})",
    "landing.as_written": "As written in English",
    "landing.copy_say": "Copy what to say",
    "landing.copied": "Copied. Show it or read it out at the counter.",
    "landing.ask_title": "Ask the guide",
    "landing.ask_placeholder": "Where can I stay? How do I open a bank account?",
    "landing.ask_hint": "Answers are the guide's own words, with where each one comes from.",
    "landing.you_asked": "You asked: {question}",
    "landing.no_answer": "The guide has nothing on that yet.",
    "landing.no_answer_next": "Call one of the numbers below, or ask someone who knows the city.",
    "landing.by_model": "The model on this phone picked this part of the guide from its titles.",
    "landing.helplines": "Numbers to save",
    "landing.call": "Call {name} on {number}",
    "landing.places": "Places",
    "landing.places_note": "Listed from public sources, not vouched for. Call before you go.",
    "landing.kind.housing": "A place to stay",
    "landing.kind.union": "Union",
    "landing.kind.office": "Office",
    "landing.source": "Source",
    "landing.register_title": "Registration",
    "landing.register_note": "The app never fills in or sends a form for you. Open the official page and do it yourself.",
    "landing.cash_title": "Money for the first month",
    "landing.cash_note": "A rough estimate from the draft guide for {from} to {to}. Only the costs the guide lists are counted.",
    "landing.cash_total": "About {amount}",
    "landing.cash_times": "{amount} × {times} = {total}",
    "landing.free": "Free",
    "landing.not_known": "Not known yet",
    "landing.unchecked": "Not yet checked",
    "landing.unchecked_note": "What the guide's writers could not confirm. Ask a union, or call, before you rely on it.",
    "landing.mentor": "Find a mentor",
    "landing.remove": "Remove this move",
    "landing.remove_confirm": "Remove this move from this phone? What you ticked goes too.",
    "landing.remove_yes": "Remove",
    "landing.keep": "Keep it",
};
//# sourceMappingURL=landing.js.map